export const API_BASE_URL = '/api/v1';
export const API_LOGIN = `${API_BASE_URL}/tokens`;

export const API_CREATE_USER = `${API_BASE_URL}/users`;
export const API_UPDATE_USER = `${API_BASE_URL}/users/`;
export const API_SHOW_USER = `${API_BASE_URL}/users/`;

export const API_FORGOT_PASSWORD = `${API_BASE_URL}/forgot_passwords`;
export const API_NEW_PASSWORD = `${API_BASE_URL}/update_passwords/1`;

export const API_WEBINARS = `${API_BASE_URL}/webinars`;
export const API_UPCOMING_WEBINARS = `${API_BASE_URL}/upcoming_webinars`;
export const API_PREVIOUS_WEBINARS = `${API_BASE_URL}/previous_webinars`;
export const API_CURRENT_WEBINARS = `${API_BASE_URL}/current_webinars`;
export const API_LIVE_WEBINARS = `${API_BASE_URL}/cpd_live`;
export const API_RECORDED_WEBINARS = `${API_BASE_URL}/cpd_recorded`;
export const API_USERS_WEBINARS = `${API_BASE_URL}/current_webinars`;
export const API_WEBINARS_USERS = `${API_BASE_URL}/admin/webinar_users`;
export const API_WEBINARS_VIEWED_USERS = `${API_BASE_URL}/admin/webinar_users/viewed_export`;

export const API_SUBSCRIPTIONS = `${API_BASE_URL}/subscriptions`;

export const API_VIMEO_VIDEO_DATA = 'https://vimeo.com/api/v2/video/';

export const API_RESULTS = `${API_BASE_URL}/results`;

export const API_CERTIFICATES = `${API_BASE_URL}/pdf_outputs`;

export const API_HOSPITALS = `${API_BASE_URL}/hospitals`;
export const API_COUNTIES = `${API_BASE_URL}/counties`;

export const API_CONFIRM_EMAIL = `${API_BASE_URL}/confirm_email`;

// TODO REPLACE WITH ACTION CONSTANT TO SIMPLIFY
export const ERROR_TYPE_USER_CREATE_ERROR = 'ERROR_TYPE_USER_CREATE_ERROR';
export const ERROR_TYPE_USER_UPDATE_ERROR = 'ERROR_TYPE_USER_UPDATE_ERROR';
export const ERROR_TYPE_LOGIN_ERROR = 'ERROR_TYPE_LOGIN_ERROR';
export const ERROR_TYPE_REQUEST = 'ERROR_TYPE_REQUEST';


// ADMIN CONSTANTS
export const API_ADMIN_USERS = `${API_BASE_URL}/admin/users`;
export const API_ADMIN_USERS_SPONSORS = `${API_BASE_URL}/admin/user_sponsors`;
export const API_ADMIN_WEBINARS = `${API_BASE_URL}/admin/webinars`;
export const EXPORT_USERS_CSV = `${API_BASE_URL}/admin/export_users`;
export const EXPORT_WEBINARS_CSV = `${API_BASE_URL}/admin/export_webinars`;
export const API_DASHBOARDS = `${API_BASE_URL}/admin/dashboards`;
export const API_DASHBOARDS_USERS = `${API_BASE_URL}/admin/dashboards/`;

export const API_ADMIN_SPONSORS = `${API_BASE_URL}/admin/sponsors`;
export const API_SPONSORS = `${API_BASE_URL}/sponsors`;



/** WEBPACK FOOTER **
 ** ./src/constants/api.js
 **/